import { LocalDate, LocalTime } from "@js-joda/core";
import h from "trader-hyperscript";
import {
  b2fileid,
  enrollment_status,
  enrollmentid,
  formula_type,
  formulaid,
  lesson_location,
  lesson_status,
  lessongroupid,
  lessonid,
  planningmode,
  studentid,
  teacherid,
} from "../../../sql/classy/types";
import { parseLessonStatus } from "../../parsing_from_ur";
import {
  HHmm,
  renderFirstNameLastName,
  renderLessonLocation,
} from "../../render";
import * as routes from "../../routes";
import { renderLessonStatusCircle } from "../teacher_lessonroster/client";
import * as joda from "@js-joda/core";
import { maybeRenderFlexCount } from "../planning/selectionandforms";

type lesson = {
  id: lessonid;
  date: LocalDate;
  time: LocalTime;
  lessongroup: {
    id: lessongroupid;
    numberoflessons: number;
    planningMode: planningmode;
    type: formula_type;
    lastlesson: LocalDate | null;
  };
  formula: {
    id: formulaid;
    numberoflessons: number;
  };
  students:
    | {
        id: studentid;
        enrollmentid: enrollmentid;
        firstname: string;
        lastname: string;
        enrollment_startedlessonson: joda.LocalDate;
        enrollment_stoppedlessonson: joda.LocalDate | null;
        enrollment_status: enrollment_status;
      }[]
    | null;
  teacher: {
    id: teacherid;
    firstname: string;
    lastname: string;
  };
  location: {
    location: lesson_location;
    room_description: string | null;
  };
};

type presence = {
  studentid: studentid;
  lessonid: lessonid;
  status: lesson_status;
  createdby: string;
  createdon: LocalDate;
  comments: string;
  storagefileid: b2fileid | null;
  needsadmincheck: boolean;
};

export function render(opts: {
  noworsoon: "now" | "soon";
  lessons: lesson[];
  presences: presence[];
}): HTMLElement | HTMLElement[] {
  if (opts.lessons.length === 0) {
    const text =
      opts.noworsoon === "now"
        ? "Er zijn op dit moment geen lessen bezig"
        : "Er zijn geen lessen die binnenkort beginnen.";
    return <div>{text}</div>;
  }

  return (
    <table>
      <tr>
        <th>{"Student"}</th>
        <th>{"Lessenreeks"}</th>
        <th>{"Lokaal"}</th>
        <th>{"Les"}</th>
      </tr>
      {opts.lessons
        .orderBy((l) =>
          (l.students || []).map(renderFirstNameLastName).join(", "),
        )
        .map((l) => {
          return (
            <tr>
              <td>
                <b>
                  {(l.students || []).map(renderFirstNameLastName).join(", ")}
                  {l.lessongroup.lastlesson &&
                  l.lessongroup.lastlesson.isEqual(l.date) ? (
                    <span style="margin-left: 4px; color: orange">
                      (* {"laatste les"}
                      {maybeRenderFlexCount(l.lessongroup, l.formula)})
                    </span>
                  ) : (
                    <span></span>
                  )}
                </b>
              </td>
              <td>
                <a
                  href={routes.lessongroup_generalRoute.link({
                    lessongroupid: l.lessongroup.id,
                  })}
                >
                  {"%time bij %teacher"
                    .replace("%time", l.time.format(HHmm))
                    .replace("%teacher", renderFirstNameLastName(l.teacher))}
                </a>
              </td>
              <td>
                {renderLessonLocation(
                  l.location.location,
                  l.location.room_description,
                )}
              </td>
              <td>
                {renderLessonStatusCircle(
                  l.date,
                  l.lessongroup.type,
                  l.students || [],
                  opts.presences
                    .filter((p) => p.lessonid === l.id)
                    .map((s) => ({
                      status: parseLessonStatus(s.status),
                      studentid: s.studentid,
                    })),
                  "margin-right: 8px; display: inline-block; border: 1px solid grey;",
                )}
                <a
                  href={routes.teacher_lessonrosterRoute.link({
                    teacherid: l.teacher.id,
                    date: l.date,
                    mode: undefined,
                  })}
                >
                  {"Les"}
                </a>
              </td>
            </tr>
          );
        })}
    </table>
  );
}
